// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RQum","top":"styles_top__blOgT","left":"styles_left__2on5a","description":"styles_description__1UQeO"};